import React from 'react';
import defaultLogo from 'assets/img/icons/logo.png';
import classNames from 'classnames';
import useSiteConfig from 'hooks/useSiteConfig';

interface LogoProps {
  width?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const Logo = ({ width = 27, text = true, textClass, className }: LogoProps) => {
  const siteConfig = useSiteConfig();
  const logoSrc = siteConfig?.LogoUrl || defaultLogo;
  const brandTitle =
    siteConfig?.SiteName ||
    siteConfig?.Title ||
    process.env.REACT_APP_TITLE ||
    'Flexmerch';
  const tagline = siteConfig?.Tagline;

  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img
        src={logoSrc}
        alt={brandTitle}
        width={width}
        style={{ maxHeight: '32px', width: 'auto' }}
      />
      {text && (
        <div className="ms-2">
          <p className={classNames(textClass, 'logo-text')}>{brandTitle}</p>
          {tagline && (
            <p className="text-body-tertiary mb-0 fs-10 fw-normal d-none d-sm-block">
              {tagline}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default Logo;
